import { render, staticRenderFns } from "./WrongIpDownload.vue?vue&type=template&id=ec928c50&"
import script from "./WrongIpDownload.vue?vue&type=script&lang=js&"
export * from "./WrongIpDownload.vue?vue&type=script&lang=js&"
import style0 from "./WrongIpDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports